export const applicationConfig = {
  careersEmail: 'careers@lloydjames.com',
  companyName: 'Lloyd James',
  websiteName: 'Lloyd James',
  teamImage: '/Image/careers-team-at-work.png',
};
